export default __webpack_public_path__ + "static/media/enghien06.f3c23b6a.jpg";